import React from 'react';

import { Link } from 'react-router-dom'

// TODO: Extract out to be a generic component and let list accept any component to render when no data is passed.
const NoAssets = (props) => (
    <div>
        <h3 className="pt-5 text-center">No assets matching your search</h3>
        <h5 className="text-center">To view all assets go to <Link to={`/browse`}>browse</Link></h5>
    </div>
)

function List({items, component, customClass, customId}) {
    const ComponentToRender = component;
    let content = (<div></div>);
    if (items && items.length > 0) {
        content = items.map((item, index) => (
            <ComponentToRender key={`item-${index}`} item={item} />
        ));
    } else {
      // Otherwise render a error component
      content = NoAssets();
    }

    return (
      <ul className={customClass} id={customId}>
        {content}
      </ul>
    );
  }

export default List;



// WEBPACK FOOTER //
// ./src/components/common/List/List.js